import type {CardApiModel, PaymentApiModel} from '../../../api/payment';

import {paymentStore} from '../../../api/payment';
import {envManager} from '../../env';

export type Handle3dSecureFn = (
  url: string,
  returnUrl: string,
  paymentId: string,
) => Promise<void>;

export type ReturnUrl = string;

export const handleRequiresActionPayment = async ({
  card,
  clientSecret,
  handle3dSecure,
  payment,
  returnUrl,
}: {
  card: CardApiModel;
  clientSecret?: string;
  handle3dSecure: Handle3dSecureFn;
  payment: PaymentApiModel;
  returnUrl: ReturnUrl;
}) => {
  if (payment.status === 'requires_action' && clientSecret) {
    const stripeConfirmIntentResponse = await fetch(
      `https://api.stripe.com/v1/payment_intents/${payment.payment_id}/confirm`,
      {
        body: [
          `payment_method=${card.pm_id}`,
          `client_secret=${clientSecret}`,
          `return_url=${encodeURIComponent(returnUrl)}`,
        ].join('&'),
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${envManager.get('stripeKey')}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
      },
    );

    const stripeConfirmIntentResponseJson =
      (await stripeConfirmIntentResponse.json()) as {
        error?: any;
        next_action?: {
          redirect_to_url: {
            url: string;
          };
        };
        status: string;
      };

    if (stripeConfirmIntentResponseJson.error) {
      throw stripeConfirmIntentResponseJson.error;
    }

    if (
      stripeConfirmIntentResponseJson.status === 'requires_action' &&
      stripeConfirmIntentResponseJson.next_action
    ) {
      await handle3dSecure(
        stripeConfirmIntentResponseJson.next_action.redirect_to_url.url,
        returnUrl,
        payment._id,
      );
    }

    return await paymentStore.execute(payment);
  }
};
